import { useMemo } from 'react';
import { prop } from 'ramda';
import { noop } from 'js/utils/methods.util';
import { useLocation } from 'react-router-dom';
import { useAppSelector, usePageSelector } from 'js/store/hooks';
import { useNavigateToPopupBackgroundPage } from 'js/components/system/Router/components/PageRouter/hooks';

import { isPageInPopupModal, getPredefinedOnClose } from '../helpers';

export const useGetOnPageAsPopupCloseMethods = ({ rootClassNames = '' }) => {
    const location = useLocation();
    const dynamicTags = useAppSelector(prop('dynamicTags'));
    const onPageAsPopupClose = useNavigateToPopupBackgroundPage();
    const predefinedOnClose = getPredefinedOnClose(rootClassNames);
    const popupBackgroundPagePath = usePageSelector(prop('popupBackgroundPagePath'));
    const isModal = popupBackgroundPagePath && isPageInPopupModal(dynamicTags, location.pathname);

    return useMemo(() => ({
        onClose: isModal && predefinedOnClose ? predefinedOnClose : onPageAsPopupClose,
        onOverlayClick: isModal ? noop : onPageAsPopupClose
    }), [isModal, predefinedOnClose, onPageAsPopupClose]);
};
